<template>
  <div>
    <div class="ckeck-box" style="margin-right: 12px;">
      <div class="title"><img :src="ossPath + '/pages/home/location_new.png'" alt=""/>起运地</div>
      <!-- <el-radio-group v-model="startCity" @change="changeStart"> -->
        <!--<el-radio v-model="startCity" style="margin-right: 50px; font-size: 16px; vertical-align: middle" :style="{marginRight: i+1 === startData.length ? 0 :'60px'}"  v-for="(item, i) in startData" :key="i" :label="item.id" @change="changeStart(item)">
          {{item.namec}}
        </el-radio>-->
      <el-select v-model="startCity" @change="changeStart">
        <el-option v-for="(item, i) in startData" :key="i" :label="item.namec" :value="item.id"></el-option>
      </el-select>
      <i class="el-icon-loading" v-if="loadingCity"></i>
      <!-- </el-radio-group> -->
      <div class="flex-1"></div>
      <slot/>
    </div>

    <div class="ckeck-box">
      <span class="title" style="margin-right: 15px;"><img :src="ossPath + '/pages/home/service_earth_new.png'">目的洲</span>
      <i class="el-icon-loading" v-if="loadingTabs"></i>
      <template v-else>
      <!-- <el-radio-group v-model="endContinents" @change="changeEndContinents"> -->
        <el-radio v-model="endContinents" style=" font-size: 16px; vertical-align: middle;" :style="{marginRight: i+1 === endContinentsData.length ? 0 :'40px'}" v-for="(item, i) in endContinentsData" :key="i" :label="item.value" @change="changeEndContinents(item)">
          {{item.label}}({{ item.total }})
        </el-radio>
      <!-- </el-radio-group> -->
      </template>
    </div>
  </div>
</template>

<script>
let defaultList = [
  {label:"全部",value:"all",total:0,},
  {label:"北美洲",value:"bmz",total:0,},
  {label:"大洋洲",value:"dyz",total:0,},
  {label:"亚洲",value:"yz",total:0,},
  {label:"非洲",value:"fz",total:0,},
  {label:"欧洲",value:"oz",total:0,},
  {label:"南美洲",value:"nmz",total:0,},
  {label:"南极洲",value:"njz",total:0,},
];
export default {
  name: 'startEndCheck',
  props:{
    defaultStartSelect:{
      type:[String,Number],
      default:"",
    },
    // 起运城市列表
    startData: {
      type:Array,
      default:()=> [],
    },
    // 大洲tab列表
    endContinentsData:{
      type:Array,
      default:()=> defaultList,
    },
    // defaultEndSelect:{
    //   type:[String,Number],
    //   default:"all",
    // },
    // 正在加载城市
    loadingCity:Boolean,
    // 正在加载洲tabs
    loadingTabs:Boolean,
  },
  data() {
    const ossPath = this.ossPath;
    return {
      startCity: '',
      endContinents: 'all',
      ossPath
    }
  },
  watch:{
    defaultStartSelect:{
      immediate:true,
      handler(val){
        this.startCity = val
      }
    },
    // defaultEndSelect:{
    //   immediate:true,
    //   handler(val){
    //     this.endContinents = val
    //   }
    // }
  },
  mounted() {
    // this.getStrat()
  },
  methods: {
    // getStrat() {
    //   this.axios
    //     .post("/filedata/findAllFromCity", {})
    //     .then((res) => {
    //       console.log("起运地: ", res)
    //       if (res.data.code === 200) {
    //         if (res.data.datas) {
    //           const result = []
    //           res.data.datas.filter(v => {
    //             return v.code !== '热门'
    //           }).forEach(item => {
    //             Array.contact(result, item.fromCityDTOList.map(v => {
    //               return {
    //                 ...v,
    //                 total: 0
    //               }
    //             }))
    //           })
    //           this.startData = result
    //         }
    //       }
    //     })
    //     .catch((res) => { })
    // },
    changeStart(val) {
      this.startCity = val
      this.endContinents = 'all'
      this.$emit('changeStart', val)
    },
    changeEndContinents(item) {
      this.$emit("update:defaultEndSelect",item.value)
      this.$emit('changeEnd', item.value, item)
    }
  }
}
</script>

<style lang="scss" scoped>
  .ckeck-box {
    position: relative;
    min-height: 40px;
    line-height: 40px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    .title {
      display: flex;
      align-items: center;
      img {
        width: 15px;
        height: auto;
        margin-right: 5px;
      }
    }
  }
  /deep/ .el-input__inner {
    width: 80px;
    border: none;
    background-color: transparent !important;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  /deep/ .el-radio__input.is-checked {
    .el-radio__inner{
      background-color: transparent;
      background: transparent;
      &::after {
        width: 7px;
        height: 7px;
        background: #FF4D01;
        background-color: #FF4D01;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeHotRecommend/startEndCheck.vue